import { WbsItemType } from '../../../../domain/entity/WbsItemEntity'
import { ProgressReportScopeType } from '../../../../domain/entity/version-report/VersionReportVersionEntity'
import { DescendantRow } from '../../../../domain/value-object/ProjectPlanSnapshot'
import { DrilldownSource } from '../hooks/useDeliverableTaskSnapshot'

/** セルの内訳の取り方と、そこから集計対象（成果物／タスク）の行だけを残す条件。 */
export const toDrilldown = (
  scopeType: ProgressReportScopeType,
  aggregateTarget: WbsItemType | undefined
): { source: DrilldownSource; matches: (row: DescendantRow) => boolean } => ({
  source: scopeType === 'TICKET_LIST' ? 'TICKETS' : 'DESCENDANTS',
  matches: row => !aggregateTarget || row.type === aggregateTarget,
})
